<template>
    <div id="contenedor-main-listado-plantillas">
        <template
            v-if="!$vuetify.breakpoint.mobile">
            <desktop
            :soloLectura="soloLectura"
            :modulo="modulo"
            :listadoPlantillas="listadoPlantillas">
            </desktop>
        </template>
        <template
            v-else>
            <desktop
            :modulo="modulo"
            :soloLectura="soloLectura"
            :listadoPlantillas="listadoPlantillas">
            </desktop>
        </template>
    </div>
</template>

<script>
import Desktop from './Desktop.vue';
// import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoPlantillas',
  props: {
    modulo: {
      type: String,
      required: true,
    },
    listadoPlantillas: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    // Mobile,
  },
  data() {
    return {
      soloLectura: false,
    };
  },
  methods: {

  },
};
</script>

<style lang="scss">

</style>
